import {I18n} from '@aws-amplify/core';

import {PlatformLoader,} from '@flexinet/ui-components';

import {useParams} from 'react-router-dom';
import {ModalContextProvider} from "../../../context/ModalContext.tsx";
import {RecordForm} from "../forms/RecordForm.tsx";
import {useNotificationSubscription} from "../hooks/useNotificationSubscription.ts";
import {useProduct} from "../../products/hooks/useProduct.ts";
import {useEffect} from "react";

export const AddRecordButton = (
    {
        buttonText = 'Add Notification Subscription',
        size = 'sm',
    }: {
        buttonText?: string,
        size?: string,
    }
) => {

    const {id: productId} = useParams();

    if (!productId) {
        throw new Error('productId is required parameter')
    }

    const {
        record: product,
        fetchRecord
    } = useProduct(productId)

    const {createRecord} = useNotificationSubscription();

    useEffect(() => {
        fetchRecord()
    }, [])

    if (!product) {
        return <PlatformLoader/>
    }

    return (
        <ModalContextProvider
            title='Notification Subscription'
            buttonOptions={{
                variant: 'filled',
                size: size,
                label: I18n.get(buttonText),
                iconType: 'add',
            }}
        >
            <RecordForm
                record={{
                    topicArn: product.meteringServiceSnsTopicArn as string,
                }}
                handleSubmit={createRecord}
            />
        </ModalContextProvider>
    );


};
